/**
 * A synchronous gate for outbound call acquisition.
 *
 * React state intentionally cannot protect this boundary: two click handlers
 * can run before `activeCall` or `pendingOutgoing` has re-rendered. The call
 * provider keeps one instance in a ref and releases it on every terminal
 * success/failure/cancel path.
 */
export interface OutgoingCallStartGate {
  tryAcquire(): boolean;
  release(): void;
  isAcquired(): boolean;
}

export function createOutgoingCallStartGate(): OutgoingCallStartGate {
  let acquired = false;
  return {
    tryAcquire() {
      if (acquired) return false;
      acquired = true;
      return true;
    },
    release() {
      acquired = false;
    },
    isAcquired() {
      return acquired;
    },
  };
}